document.documentElement.classList.remove('no-js');

const navToggle = document.querySelector('[data-nav-toggle]');
const mobileNav = document.querySelector('[data-mobile-nav]');

if (navToggle && mobileNav) {
  navToggle.addEventListener('click', () => {
    const isOpen = navToggle.getAttribute('aria-expanded') === 'true';
    navToggle.setAttribute('aria-expanded', String(!isOpen));
    mobileNav.hidden = isOpen;
    document.body.classList.toggle('nav-open', !isOpen);
  });

  mobileNav.addEventListener('click', (event) => {
    if (!event.target.closest('a')) return;
    navToggle.setAttribute('aria-expanded', 'false');
    mobileNav.hidden = true;
    document.body.classList.remove('nav-open');
  });
}

const revealItems = document.querySelectorAll('.reveal');
if ('IntersectionObserver' in window) {
  const observer = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        entry.target.classList.add('is-visible');
        observer.unobserve(entry.target);
      }
    });
  }, { threshold: 0.12 });
  revealItems.forEach((item) => observer.observe(item));
} else {
  revealItems.forEach((item) => item.classList.add('is-visible'));
}

document.querySelectorAll('[data-product-form]').forEach((form) => {
  const productSection = form.closest('[data-product-section]');
  const json = productSection?.querySelector('[data-product-json]');
  const masterSelect = form.querySelector('[data-variant-select]');
  const optionSelects = [...form.querySelectorAll('select[name^="options"]')];
  const button = form.querySelector('button[type="submit"]');
  const price = productSection?.querySelector('[data-product-price]');
  if (!json || !masterSelect || !optionSelects.length) return;

  const variants = JSON.parse(json.textContent);
  optionSelects.forEach((select) => select.addEventListener('change', () => {
    const selected = optionSelects.map((item) => item.value);
    const variant = variants.find((item) => item.options.every((value, index) => value === selected[index]));
    if (!variant) return;
    masterSelect.value = String(variant.id);
    button.disabled = !variant.available;
    button.textContent = variant.available ? 'Add to bag' : 'Sold out';
    const matchingOption = masterSelect.querySelector(`option[value="${variant.id}"]`);
    if (price && matchingOption?.dataset.price) price.textContent = matchingOption.dataset.price;
  }));
});

const impactHero = document.querySelector('.impact-hero');
const accessCard = impactHero?.querySelector('.access-card');
const floatingLook = impactHero?.querySelector('.floating-look');

if (impactHero && matchMedia('(pointer: fine)').matches && !matchMedia('(prefers-reduced-motion: reduce)').matches) {
  impactHero.addEventListener('pointermove', (event) => {
    const bounds = impactHero.getBoundingClientRect();
    const x = (event.clientX - bounds.left) / bounds.width - 0.5;
    const y = (event.clientY - bounds.top) / bounds.height - 0.5;
    if (accessCard) accessCard.style.transform = `translate(${x * 12}px, ${y * 10}px) rotate(${4 + x * 2}deg)`;
    if (floatingLook) floatingLook.style.transform = `translate(${x * -15}px, ${y * -10}px) rotate(${-3 + x * 2}deg)`;
  });
}

const videoCards = [...document.querySelectorAll('[data-video-card], [data-video-root]')];
const reduceMotion = matchMedia('(prefers-reduced-motion: reduce)').matches;
const mobileVideoExperience = matchMedia('(max-width: 720px), (pointer: coarse)').matches;

if (videoCards.length) {
  const playCard = (card) => {
    const video = card?.querySelector('video');
    if (!video || reduceMotion) return;
    video.play().catch(() => {});
  };

  const pauseCard = (card) => {
    const video = card?.querySelector('video');
    if (video) video.pause();
  };

  if (mobileVideoExperience) {
    videoCards.forEach((card) => {
      const video = card.querySelector('video');
      if (!video) return;
      video.setAttribute('playsinline', '');
      if (card.matches('[data-video-card]')) video.pause();
    });
  }

  if ('IntersectionObserver' in window) {
    const videoObserver = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting && entry.intersectionRatio >= 0.55) playCard(entry.target);
        else pauseCard(entry.target);
      });
    }, { threshold: [0, 0.55, 0.85] });
    videoCards.forEach((card) => videoObserver.observe(card));
  }

  document.addEventListener('visibilitychange', () => {
    if (document.hidden) videoCards.forEach((card) => pauseCard(card));
  });

  document.querySelectorAll('[data-video-audio]').forEach((button) => {
    button.addEventListener('click', () => {
      const card = button.closest('[data-video-card], [data-video-root]');
      const video = card?.querySelector('video');
      if (!video) return;
      video.muted = !video.muted;
      button.setAttribute('aria-pressed', String(!video.muted));
      button.setAttribute('aria-label', video.muted ? 'Turn sound on' : 'Mute video');
      button.classList.toggle('is-audible', !video.muted);
      if (!video.muted) video.play().catch(() => {});
    });
  });

  document.addEventListener('shopify:block:select', (event) => playCard(event.target?.closest('[data-video-card]')));
}

document.querySelectorAll('[data-share-video]').forEach((button) => {
  button.addEventListener('click', async () => {
    const shareData = { title: document.title, text: 'Discover ELLA — Collection 01', url: window.location.href };
    try {
      if (navigator.share) await navigator.share(shareData);
      else if (navigator.clipboard) {
        await navigator.clipboard.writeText(window.location.href);
        const label = button.querySelector('small');
        if (label) {
          const original = label.textContent;
          label.textContent = 'copied';
          window.setTimeout(() => { label.textContent = original; }, 1600);
        }
      }
    } catch (error) {
      if (error?.name !== 'AbortError') console.warn('Unable to share this video.');
    }
  });
});

/* ELLA V6 — commerce drawers, quick shop and saved edit */
const ellaOverlay = document.querySelector('[data-drawer-overlay]');
const ellaDrawers = [...document.querySelectorAll('.ella-drawer')];
const ellaRoot = window.Shopify?.routes?.root || '/';
let ellaLastTrigger = null;

const ellaEscape = (value = '') => String(value).replace(/[&<>'"]/g, (character) => ({
  '&': '&amp;', '<': '&lt;', '>': '&gt;', "'": '&#39;', '"': '&quot;'
}[character]));

const ellaMoney = (cents = 0) => {
  if (window.Shopify?.formatMoney) return window.Shopify.formatMoney(cents);
  const currency = window.Shopify?.currency?.active || 'EUR';
  return new Intl.NumberFormat(document.documentElement.lang || 'en-IE', { style: 'currency', currency }).format(cents / 100);
};

const ellaToast = (message) => {
  const toast = document.querySelector('[data-toast]');
  if (!toast) return;
  toast.textContent = message;
  toast.hidden = false;
  window.clearTimeout(ellaToast.timer);
  ellaToast.timer = window.setTimeout(() => { toast.hidden = true; }, 2400);
};

const ellaCloseDrawers = ({ restoreFocus = true } = {}) => {
  ellaDrawers.forEach((drawer) => {
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
  });
  if (ellaOverlay) ellaOverlay.hidden = true;
  document.body.classList.remove('drawer-open');
  if (restoreFocus) ellaLastTrigger?.focus?.();
};

const ellaOpenDrawer = (drawer, trigger) => {
  if (!drawer) return;
  ellaCloseDrawers({ restoreFocus: false });
  ellaLastTrigger = trigger || document.activeElement;
  drawer.classList.add('is-open');
  drawer.setAttribute('aria-hidden', 'false');
  if (ellaOverlay) ellaOverlay.hidden = false;
  document.body.classList.add('drawer-open');
  window.setTimeout(() => drawer.querySelector('button, input, select, a')?.focus(), 80);
};

document.querySelectorAll('[data-drawer-close]').forEach((button) => button.addEventListener('click', () => ellaCloseDrawers()));
ellaOverlay?.addEventListener('click', () => ellaCloseDrawers());
document.addEventListener('keydown', (event) => { if (event.key === 'Escape') ellaCloseDrawers(); });

document.querySelectorAll('[data-search-open]').forEach((button) => button.addEventListener('click', () => {
  const drawer = document.querySelector('[data-search-drawer]');
  ellaOpenDrawer(drawer, button);
  window.setTimeout(() => drawer?.querySelector('[data-search-input]')?.focus(), 100);
}));

const ellaWishlistKey = 'ella-saved-edit';
const ellaGetWishlist = () => {
  try { return JSON.parse(localStorage.getItem(ellaWishlistKey) || '[]'); }
  catch { return []; }
};
const ellaSetWishlist = (items) => localStorage.setItem(ellaWishlistKey, JSON.stringify(items));

const ellaRenderWishlist = () => {
  const items = ellaGetWishlist();
  document.querySelectorAll('[data-wishlist-count]').forEach((node) => { node.textContent = String(items.length); });
  document.querySelectorAll('[data-wishlist-toggle]').forEach((button) => {
    const saved = items.some((item) => item.handle === button.dataset.productHandle);
    button.classList.toggle('is-saved', saved);
    button.setAttribute('aria-pressed', String(saved));
  });
  const list = document.querySelector('[data-wishlist-list]');
  const empty = document.querySelector('[data-wishlist-empty]');
  if (!list) return;
  list.innerHTML = items.map((item) => `
    <article class="ella-drawer__item">
      ${item.image ? `<img src="${ellaEscape(item.image)}" alt="" width="180" height="180">` : ''}
      <div><strong>${ellaEscape(item.title)}</strong><small>Saved to your edit</small></div>
      <div><button type="button" data-wishlist-quickshop="${ellaEscape(item.handle)}" data-product-url="${ellaEscape(item.url)}">View</button><button type="button" data-wishlist-remove="${ellaEscape(item.handle)}">Remove</button></div>
    </article>`).join('');
  if (empty) empty.hidden = items.length > 0;
};

document.addEventListener('click', (event) => {
  const toggle = event.target.closest('[data-wishlist-toggle]');
  if (toggle) {
    const items = ellaGetWishlist();
    const handle = toggle.dataset.productHandle;
    const existing = items.findIndex((item) => item.handle === handle);
    if (existing >= 0) {
      items.splice(existing, 1);
      ellaToast('Removed from your saved edit');
    } else {
      items.push({ handle, title: toggle.dataset.productTitle, url: toggle.dataset.productUrl, image: toggle.dataset.productImage });
      ellaToast('Saved to your private edit');
    }
    ellaSetWishlist(items);
    ellaRenderWishlist();
  }

  const remove = event.target.closest('[data-wishlist-remove]');
  if (remove) {
    ellaSetWishlist(ellaGetWishlist().filter((item) => item.handle !== remove.dataset.wishlistRemove));
    ellaRenderWishlist();
  }
});

document.querySelectorAll('[data-wishlist-open]').forEach((button) => button.addEventListener('click', () => {
  ellaRenderWishlist();
  ellaOpenDrawer(document.querySelector('[data-wishlist-drawer]'), button);
}));

const ellaLoadProduct = async (handle, trigger) => {
  if (!handle) return;
  const drawer = document.querySelector('[data-quickshop-drawer]');
  ellaOpenDrawer(drawer, trigger);
  drawer?.classList.add('is-loading');
  try {
    const response = await fetch(`${ellaRoot}products/${encodeURIComponent(handle)}.js`);
    if (!response.ok) throw new Error('Product unavailable');
    const product = await response.json();
    const image = drawer.querySelector('[data-quickshop-image]');
    const title = drawer.querySelector('[data-quickshop-title]');
    const price = drawer.querySelector('[data-quickshop-price]');
    const variants = drawer.querySelector('[data-quickshop-variants]');
    const link = drawer.querySelector('[data-quickshop-link]');
    if (image) { image.src = product.featured_image || product.images?.[0] || ''; image.alt = product.title || ''; }
    if (title) title.textContent = product.title || '';
    if (price) price.textContent = ellaMoney(product.price || 0);
    if (link) link.href = `${ellaRoot}products/${product.handle}`;
    if (variants) variants.innerHTML = product.variants.map((variant) => `<option value="${variant.id}" ${variant.available ? '' : 'disabled'}>${ellaEscape(variant.title)}${variant.available ? '' : ' — Sold out'}</option>`).join('');
  } catch {
    ellaCloseDrawers();
    ellaToast('This piece is not available yet');
  } finally {
    drawer?.classList.remove('is-loading');
  }
};

document.addEventListener('click', (event) => {
  const trigger = event.target.closest('[data-quickshop-open]');
  const savedTrigger = event.target.closest('[data-wishlist-quickshop]');
  if (trigger) ellaLoadProduct(trigger.dataset.productHandle, trigger);
  if (savedTrigger) ellaLoadProduct(savedTrigger.dataset.wishlistQuickshop, savedTrigger);
});

const ellaRenderCart = (cart) => {
  document.querySelectorAll('[data-cart-count]').forEach((node) => { node.textContent = String(cart.item_count || 0); });
  const list = document.querySelector('[data-cart-items]');
  const empty = document.querySelector('[data-cart-empty]');
  const summary = document.querySelector('[data-cart-summary]');
  if (list) list.innerHTML = (cart.items || []).map((item, index) => `
    <article class="ella-drawer__item">
      ${item.image ? `<img src="${ellaEscape(item.image)}" alt="" width="180" height="180">` : ''}
      <div><strong>${ellaEscape(item.product_title)}</strong><small>${ellaEscape(item.variant_title || '')} · Qty ${item.quantity}</small><small>${ellaMoney(item.final_line_price)}</small></div>
      <button type="button" data-cart-remove="${index + 1}">Remove</button>
    </article>`).join('');
  if (empty) empty.hidden = cart.item_count > 0;
  if (summary) summary.hidden = cart.item_count === 0;
  const total = document.querySelector('[data-cart-total]');
  if (total) total.textContent = ellaMoney(cart.total_price || 0);
};

const ellaFetchCart = async () => {
  const response = await fetch(`${ellaRoot}cart.js`);
  if (!response.ok) throw new Error('Unable to load cart');
  const cart = await response.json();
  ellaRenderCart(cart);
  return cart;
};

document.querySelectorAll('[data-cart-open]').forEach((button) => button.addEventListener('click', async () => {
  ellaOpenDrawer(document.querySelector('[data-cart-drawer]'), button);
  try { await ellaFetchCart(); } catch { ellaToast('Your bag could not be loaded'); }
}));

document.addEventListener('click', async (event) => {
  const remove = event.target.closest('[data-cart-remove]');
  if (!remove) return;
  remove.disabled = true;
  try {
    const response = await fetch(`${ellaRoot}cart/change.js`, {
      method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ line: Number(remove.dataset.cartRemove), quantity: 0 })
    });
    if (!response.ok) throw new Error('Unable to update cart');
    ellaRenderCart(await response.json());
  } catch { ellaToast('Your bag could not be updated'); }
});

const ellaAddToCart = async (id, quantity = 1) => {
  const response = await fetch(`${ellaRoot}cart/add.js`, {
    method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: [{ id: Number(id), quantity: Number(quantity) || 1 }] })
  });
  if (!response.ok) throw new Error('Unable to add product');
  await ellaFetchCart();
  ellaOpenDrawer(document.querySelector('[data-cart-drawer]'));
  ellaToast('Added to your selection');
};

document.querySelector('[data-quickshop-form]')?.addEventListener('submit', async (event) => {
  event.preventDefault();
  const submit = event.currentTarget.querySelector('button[type="submit"]');
  submit.disabled = true;
  try { await ellaAddToCart(new FormData(event.currentTarget).get('id')); }
  catch { ellaToast('This piece could not be added'); }
  finally { submit.disabled = false; }
});

document.querySelectorAll('[data-product-form]').forEach((form) => form.addEventListener('submit', async (event) => {
  event.preventDefault();
  const submit = form.querySelector('button[type="submit"]');
  submit.disabled = true;
  const data = new FormData(form);
  try { await ellaAddToCart(data.get('id'), data.get('quantity') || 1); }
  catch { ellaToast('This piece could not be added'); }
  finally { submit.disabled = false; }
}));

ellaRenderWishlist();
